import { render } from "./ConfigManager.vue?vue&type=template&id=057d07ef"
import script from "./ConfigManager.vue?vue&type=script&lang=js"
export * from "./ConfigManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__